// Only what en-GB says differently; every other string is en-US (mergeLocaleResources).
export const activity = {} as const;
